module.exports = __webpack_public_path__ + "img/mental.efcde8f2.webp";